import { Turbo } from "@hotwired/turbo-rails";
import "preline";
import { runComponentPackages, runControllerPackage } from "@lib/packageRunner";
import { application } from "@controllers/application";
import ProfileController from "@controllers/common/profile/profile";
import ModalController from "@controllers/common/modal/modal";
import PrelineModalController from "@controllers/preline/modal/modal";
import MapsController from "@controllers/common/google/google_maps";
import FieldError from "@controllers/common/field-error/field-error";
import TeamController from "@controllers/team/team";
import CarouselController from "@controllers/preline/carousel/carousel";
import MultiCarouselController from "@controllers/preline/carousel/multi-carousel";
import DatepickerController from "@controllers/common/datepicker/datepicker";
import B2bOnboardingFormController from "@controllers/preline/b2b_onboarding/b2b_onboarding_form";
import ProgressController from "@controllers/preline/progress/progress";
import VenueController from "@controllers/dashboard/memorial_venues/venue";
import LoadingController from "@controllers/preline/loading/loading";

application.register("team", TeamController);
application.register("modal", ModalController);
application.register("preline-modal", PrelineModalController);
application.register("google_maps", MapsController);
application.register("profile", ProfileController);
application.register("field-error", FieldError);
application.register("carousel", CarouselController);
application.register("multi-carousel", MultiCarouselController);
application.register("datepicker", DatepickerController);
application.register("b2b-onboarding-form", B2bOnboardingFormController);
application.register("loading", LoadingController);
application.register("progress", ProgressController);
application.register("venue", VenueController);

Turbo.session.drive = false;
document.addEventListener("DOMContentLoaded", async () => {
  runControllerPackage();
  runComponentPackages();
});

document.documentElement.addEventListener("turbo:frame-load", () => {
  window.HSStaticMethods.autoInit();
  runControllerPackage();
  runComponentPackages();
});
